{
  "name": "velo-back-office",
  "version": "1.3.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local": "ng serve --configuration=local",
    "start:quality": "ng serve --configuration=quality",
    "build": "ng build",
    "build:dev": "ng build --configuration=development --output-path=dist/velo-back-office-dev",
    "build:qa": "ng build --configuration=quality --output-path=dist/velo-back-office-qa",
    "build:prod": "ng build --configuration=production --output-path=dist/velo-back-office-prod",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "serve:ssr:velo-back-office": "node dist/velo-back-office/server/server.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.0",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.0",
    "@angular/compiler": "^19.2.0",
    "@angular/core": "^19.2.0",
    "@angular/forms": "^19.2.0",
    "@angular/platform-browser": "^19.2.0",
    "@angular/platform-browser-dynamic": "^19.2.25",
    "@angular/platform-server": "^19.2.0",
    "@angular/router": "^19.2.0",
    "@angular/ssr": "^19.2.0",
    "@ngrx/signals": "^19.2.1",
    "@primeng/themes": "^19.0.0",
    "crypto-js": "^4.2.0",
    "express": "^4.21.2",
    "leaflet": "1.9.4",
    "primeicons": "^7.0.0",
    "primelocale": "^2.5.0",
    "primeng": "^19.0.0",
    "quill": "^2.0.3",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.0",
    "@angular/cli": "^19.2.0",
    "@angular/compiler-cli": "^19.2.0",
    "@tailwindcss/postcss": "^4.0.0",
    "@types/crypto-js": "^4.2.2",
    "@types/express": "^4.17.21",
    "@types/jasmine": "~5.1.0",
    "@types/leaflet": "1.9.20",
    "@types/node": "^22.12.0",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.5.0",
    "prettier": "^3.5.0",
    "tailwindcss": "^4.0.0",
    "typescript": "~5.7.2"
  }
}
